import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { ListItem, ListItemIcon, ListItemText, Divider, Collapse, List } from '@mui/material';
import {
  HomeOutlined, ExpandLess, ExpandMore,
  TrendingUpOutlined, AccountBalanceWalletOutlined, NewspaperOutlined,
  CloseOutlined, PeopleAltOutlined, ConfirmationNumberOutlined,
  LocationOnOutlined, SettingsOutlined,
  LocalOfferOutlined,
  PointOfSaleOutlined,
  DesignServicesOutlined,
  PersonOutlineOutlined,
  ArrowBackOutlined,
  StoreOutlined,
  AssignmentIndOutlined,
  AttachMoney
} from '@mui/icons-material';
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ScannerApkModal from '../modales/ScannerApkModal';

const EventMenu = ({ eventoId, userRole, toggleDrawer, setQROption, closeMenus, drawerOpen, expandedMenus, toggleExpandMenu, eventoActual, keepDrawerOpen = true, isMobile }) => {
  const [t] = useTranslation("global");
  const location = useLocation();
  const currentPath = location.pathname;

  const [scannerModalOpen, setScannerModalOpen] = useState(false);

  const isActive = (path) => {
    return currentPath === path;
  };

  const isPathActive = (path) => {
    return currentPath === path || currentPath.startsWith(path + '/');
  };

  const isExpandedMenuActive = (menuKey) => {
    switch (menuKey) {
      case "menu-data":
        return isActive(`/eventos/${eventoId}/tarifas`) ||
          isActive(`/eventos/${eventoId}/ubicaciones`) ||
          isActive(`/eventos/${eventoId}/editar`) ||
          isActive(`/eventos/${eventoId}/impresion`) ||
          isActive(`/eventos/${eventoId}/publicaciones`) ||
          isActive(`/eventos/${eventoId}/cuentas`);

      case "menu-sales":
        return isPathActive(`/eventos/${eventoId}/ventas`) ||
          isPathActive(`/eventos/${eventoId}/tickets`) ||
          isPathActive(`/eventos/${eventoId}/vouchers`);

      case "menu-pos":
        return isActive(`/eventos/${eventoId}/caja-stock`) ||
          isActive(`/eventos/${eventoId}/venta-presencial`) ||
          isActive(`/eventos/${eventoId}/ventas-caja`) ||
          isActive(`/eventos/${eventoId}/caja-resumen`);

      default:
        return false;
    }
  };

  //si estamos dentro de un menu, lo expandimos pero permitimos que se cierre 
  const handleExpandableMenuClick = (menuKey) => {
    toggleExpandMenu(menuKey);
  };

  useEffect(() => {
    if (!drawerOpen) return;
    if (isExpandedMenuActive("menu-data") && !expandedMenus["menu-data"]) {
      toggleExpandMenu("menu-data");
    }
    if (isExpandedMenuActive("menu-sales") && !expandedMenus["menu-sales"]) {
      toggleExpandMenu("menu-sales");
    }
    if (isExpandedMenuActive("menu-pos") && !expandedMenus["menu-pos"]) {
      toggleExpandMenu("menu-pos");
    }
  }, [currentPath, drawerOpen]);

  const closeAllExpandedMenus = () => {
    const expandableMenus = ["menu-data", "menu-sales", "menu-pos"];

    // mantenemos abierto solo el menu que corresponde
    expandableMenus.forEach(menuKey => {
      const shouldBeOpen = isExpandedMenuActive(menuKey);
      if (expandedMenus[menuKey] !== shouldBeOpen) {
        toggleExpandMenu(menuKey);
      }
    });
  };

  const handleItemClick = (customAction) => {
    if (isMobile) {
      closeMenus();
      if (typeof window !== "undefined") {
        window.localStorage.setItem("drawerClosedManually", "true");
      }
    }
    closeAllExpandedMenus();
    if (customAction && typeof customAction === 'function') {
      customAction();
    }
  };

  const handleScannerClick = (e) => {
    e.preventDefault();
    setScannerModalOpen(true);
  };

  return (
    <>
      {/* INICIO PASSGO */}
      <ListItem
        button
        component={Link}
        to="/"
        onClick={() => handleItemClick()}
        className="drawer-item"
      >
        <ListItemIcon sx={{ minWidth: "40px" }}><HomeOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
        <ListItemText primary={t("navbar.home")} primaryTypographyProps={{
          fontFamily: "Bricolage Grotesque",
          sx: { fontSize: "14px", color: "#4B4D63", fontWeight: isActive(`/`) ? 600 : 400 }
        }} />
      </ListItem>

      {/* HOME - DASHBOARD */}
      {userRole !== 3 && userRole !== 8 && userRole !== 9 && (
        <ListItem
          button
          component={Link}
          to={`/eventos/${eventoId}`}
          onClick={() => handleItemClick()}
          className="drawer-item"
          sx={{
            color: "#4B4D63",
            textDecoration: "none",
          }}
        >
          <ListItemIcon sx={{ minWidth: "40px" }}><TrendingUpOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText primary="Panel de control" primaryTypographyProps={{
            fontFamily: "Bricolage Grotesque",
            sx: {
              fontSize: "14px",
              color: "#4B4D63",
              fontWeight: isActive(`/eventos/${eventoId}`) ? 600 : 400
            }
          }} />
        </ListItem>
      )}

      {/* CONFIGURACIÓN DEL EVENTO */}
      {userRole !== 5 && userRole !== 3 && userRole !== 6 && userRole !== 7 && userRole !== 8 && userRole !== 9 && userRole !== 10 && eventoActual?.id_estados_eventos !== 4 && (
        <>
          <ListItem
            button
            onClick={() => handleExpandableMenuClick("menu-data")}
            className="drawer-item"
            sx={{
              color: "#4B4D63",
              textDecoration: "none",
              backgroundColor: isExpandedMenuActive("menu-data") ? 'rgba(11, 0, 98, 0.08)' : 'transparent',
            }}
          >
            <ListItemIcon sx={{ minWidth: "40px" }}>
              <SettingsOutlined style={{
                color: "#4B4D63",
                fontWeight: isExpandedMenuActive("menu-data") ? 600 : 400
              }} />
            </ListItemIcon>
            <ListItemText
              primary="Configuración del evento"
              primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: {
                  fontSize: "14px",
                  color: "#4B4D63",
                  fontWeight: isExpandedMenuActive("menu-data") ? 600 : 400
                }
              }}
            />
            {expandedMenus["menu-data"] ?
              <ExpandLess style={{ color: "#4B4D63" }} /> :
              <ExpandMore style={{ color: "#4B4D63" }} />
            }
          </ListItem>

          <Collapse in={expandedMenus["menu-data"]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* PUBLICACIONES */}
              {userRole !== 2 && userRole !== 5 && userRole !== 6 && eventoActual?.privado !== true && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/publicaciones`}
                  onClick={() => handleItemClick()}
                  sx={{
                    pl: 4,

                  }}
                  className="drawer-item"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><NewspaperOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText primary={t("menuTemplate.publications")} primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: {
                      fontSize: "14px",
                      color: "#4B4D63",
                      fontWeight: isActive(`/eventos/${eventoId}/publicaciones`) ? 600 : 400
                    }
                  }} />
                </ListItem>
              )}
              {/* EDITAR EVENTO */}
              {userRole === 1 && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/editar`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><SettingsOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary={t("menuTemplate.eventConfiguration")}
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isActive(`/eventos/${eventoId}/editar`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

              {/* TARIFAS */}
              {userRole === 1 && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/tarifas`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><LocalOfferOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Entradas y precios"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isActive(`/eventos/${eventoId}/tarifas`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

              {/* UBICACIONES */}
              {userRole !== 3 && !isMobile && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/ubicaciones`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><LocationOnOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Ubicaciones"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isActive(`/eventos/${eventoId}/ubicaciones`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

              {/* DISEÑO DE TICKETS */}
              {(userRole === 1 || userRole === 7) && !isMobile && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/impresion`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><DesignServicesOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Diseño de tickets"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isActive(`/eventos/${eventoId}/impresion`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

              {/* CARTERAS */}
              {userRole === 1 && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/cuentas`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><AccountBalanceWalletOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Cobros y pagos"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isActive(`/eventos/${eventoId}/cuentas`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}
            </List>
          </Collapse>
        </>
      )}

      {/* VENTAS Y CONTROL */}
      {userRole !== 5 && userRole !== 6 && userRole !== 8 && userRole !== 9 && userRole !== 10 && (
        <>
          <ListItem
            button
            onClick={() => handleExpandableMenuClick("menu-sales")}
            className="drawer-item"
            sx={{
              color: "#4B4D63",
              textDecoration: "none",
            }}
          >
            <ListItemIcon sx={{ minWidth: "40px" }}>
              <PointOfSaleOutlined style={{
                color: "#4B4D63",
                fontWeight: isExpandedMenuActive("menu-sales") ? 600 : 400
              }} />
            </ListItemIcon>
            <ListItemText
              primary="Ventas y Control"
              primaryTypographyProps={{
                fontFamily: "Bricolage Grotesque",
                sx: {
                  fontSize: "14px",
                  color: "#4B4D63",
                  fontWeight: isExpandedMenuActive("menu-sales") ? 600 : 400
                }
              }}
            />
            {expandedMenus["menu-sales"] ?
              <ExpandLess style={{ color: "#4B4D63" }} /> :
              <ExpandMore style={{ color: "#4B4D63" }} />
            }
          </ListItem>

          <Collapse in={expandedMenus["menu-sales"]} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {/* VENTAS */}
              {userRole !== 2 && userRole !== 5 && userRole !== 6 && userRole !== 7 && userRole !== 9 && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/ventas`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><TrendingUpOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Ventas realizadas"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isPathActive(`/eventos/${eventoId}/ventas`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

              {/* TICKETS */}
              {userRole !== 9 && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/tickets`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><ConfirmationNumberOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Tickets"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isPathActive(`/eventos/${eventoId}/tickets`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

              {/* VOUCHERS */}
              {userRole !== 9 && (
                <ListItem
                  button
                  component={Link}
                  to={`/eventos/${eventoId}/vouchers`}
                  sx={{
                    pl: 4,
                  }}
                  onClick={() => handleItemClick()}
                  className="drawer-subitem"
                >
                  <ListItemIcon sx={{ minWidth: "40px" }}><LocalOfferOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
                  <ListItemText
                    primary="Vouchers"
                    primaryTypographyProps={{
                      fontFamily: "Bricolage Grotesque",
                      sx: {
                        fontSize: "14px",
                        color: "#4B4D63",
                        fontWeight: isPathActive(`/eventos/${eventoId}/vouchers`) ? 600 : 400
                      }
                    }}
                  />
                </ListItem>
              )}

            </List>
          </Collapse>
        </>
      )}

      {/*  {(userRole === 10 || userRole === 1) && eventoActual?.id_estados_eventos !== 4 &&(
        <ListItem
          button
          component={Link}
          to={`/eventos/${eventoId}/talonarios`}
          onClick={() => handleItemClick()}
          className="drawer-item"
        >
          <ListItemIcon sx={{ minWidth: "40px" }}><AssignmentIndOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText
            primary="Talonarios"
            primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: {
                fontSize: "14px",
                color: "#4B4D63",
                fontWeight: isActive(`/eventos/${eventoId}/talonarios`) ? 600 : 400
              }
            }}
          />
        </ListItem>
      )}

      {userRole !== 3 && userRole !== 5 && userRole !== 7 && userRole !== 8 &&  eventoActual?.id_estados_eventos !== 4 && (
        <ListItem
          button
          component={Link}
          to={`/eventos/${eventoId}/caja`}
          onClick={() => handleItemClick()}
          className="drawer-item"
        >
          <ListItemIcon sx={{ minWidth: "40px" }}><StoreOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText
            primary="Venta presencial"
            primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: {
                fontSize: "14px",
                color: "#4B4D63",
                fontWeight: isActive(`/eventos/${eventoId}/caja`) ? 600 : 400
              }
            }}
          />
        </ListItem>
      )}

      {userRole !== 3 && userRole !== 5 && userRole !== 7 && userRole !== 8 &&  eventoActual?.id_estados_eventos !== 4 && (
        <ListItem
          button
          component={Link}
          to={`/eventos/${eventoId}/ventas-caja`}
          onClick={() => handleItemClick()}
          className="drawer-item"
        >
          <ListItemIcon sx={{ minWidth: "40px" }}><TrendingUpOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText
            primary="Registro de ventas"
            primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: {
                fontSize: "14px",
                color: "#4B4D63",
                fontWeight: isActive(`/eventos/${eventoId}/ventas-caja`) ? 600 : 400
              }
            }}
          />
        </ListItem>
      )}

      {userRole !== 3 && userRole !== 5 && userRole !== 7 && userRole !== 8 && userRole !== 9 && userRole !== 10 &&  eventoActual?.id_estados_eventos !== 4 && (
        <ListItem
          button
          component={Link}
          to={`/eventos/${eventoId}/caja-resumen`}
          onClick={() => handleItemClick()}
          className="drawer-item"
        >
          <ListItemIcon sx={{ minWidth: "40px" }}><AttachMoney style={{ color: "#4B4D63" }} /></ListItemIcon>
          <ListItemText
            primary="Caja"
            primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: {
                fontSize: "14px",
                color: "#4B4D63",
                fontWeight: isActive(`/eventos/${eventoId}/caja-resumen`) ? 600 : 400
              }
            }}
          />
        </ListItem>
      )} */}

      {/* PUNTO DE VENTA --- VENTAS PRESENCIALES */}
      {userRole !== 5 && userRole !== 6 && userRole !== 8 && eventoActual?.id_estados_eventos !== 4 && (
        <>
          {/* PARA OWNERS */}
          {(userRole === 1 || userRole === 10) ? (
            <>
              <ListItem
                button
                onClick={() => handleExpandableMenuClick("menu-pos")}
                className="drawer-item"
                sx={{
                  color: "#4B4D63",
                  textDecoration: "none",
                  backgroundColor: isExpandedMenuActive("menu-pos") ? 'rgba(11, 0, 98, 0.08)' : 'transparent',
                }}
              >
                <ListItemIcon sx={{ minWidth: "40px" }}>
                  <StoreOutlined style={{
                    color: "#4B4D63",
                    fontWeight: isExpandedMenuActive("menu-pos") ? 600 : 400
                  }} />
                </ListItemIcon>
                <ListItemText
                  primary="Punto de Venta"
                  primaryTypographyProps={{
                    fontFamily: "Bricolage Grotesque",
                    sx: {
                      fontSize: "14px",
                      color: "#4B4D63",
                      fontWeight: isExpandedMenuActive("menu-pos") ? 600 : 400
                    }
                  }}
                />
                {expandedMenus["menu-pos"] ?
                  <ExpandLess style={{ color: "#4B4D63" }} /> :
                  <ExpandMore style={{ color: "#4B4D63" }} />
                }
              </ListItem>

              <Collapse in={expandedMenus["menu-pos"]} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>

                  {/* CAJA Y STOCK */}
                  <ListItem
                    button
                    component={Link}
                    to={`/eventos/${eventoId}/caja-stock`}
                    sx={{ pl: 4 }}
                    onClick={() => handleItemClick()}
                    className="drawer-subitem"
                  >
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <AssignmentIndOutlined style={{ color: "#4B4D63" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Caja y Stock"
                      primaryTypographyProps={{
                        fontFamily: "Bricolage Grotesque",
                        sx: {
                          fontSize: "14px",
                          color: "#4B4D63",
                          fontWeight: isActive(`/eventos/${eventoId}/caja-stock`) ? 600 : 400
                        }
                      }}
                    />
                  </ListItem>

                  {/* VENTA PRESENCIAL -- VISTA PARA VENDER */}
                  <ListItem
                    button
                    component={Link}
                    to={`/eventos/${eventoId}/venta-presencial`}
                    sx={{ pl: 4 }}
                    onClick={() => handleItemClick()}
                    className="drawer-subitem"
                  >
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <PointOfSaleOutlined style={{ color: "#4B4D63" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Venta presencial"
                      primaryTypographyProps={{
                        fontFamily: "Bricolage Grotesque",
                        sx: {
                          fontSize: "14px",
                          color: "#4B4D63",
                          fontWeight: isActive(`/eventos/${eventoId}/venta-presencial`) ? 600 : 400
                        }
                      }}
                    />
                  </ListItem>

                  {/* HISTORIAL DE VENTAS */}
                  <ListItem
                    button
                    component={Link}
                    to={`/eventos/${eventoId}/ventas-caja`}
                    sx={{ pl: 4 }}
                    onClick={() => handleItemClick()}
                    className="drawer-subitem"
                  >
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <TrendingUpOutlined style={{ color: "#4B4D63" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Historial de ventas"
                      primaryTypographyProps={{
                        fontFamily: "Bricolage Grotesque",
                        sx: {
                          fontSize: "14px",
                          color: "#4B4D63",
                          fontWeight: isActive(`/eventos/${eventoId}/ventas-caja`) ? 600 : 400
                        }
                      }}
                    />
                  </ListItem>

                  {/* RESUMEN DE CAJA */}
                  {userRole === 1 && (
                    <ListItem
                      button
                      component={Link}
                      to={`/eventos/${eventoId}/caja-resumen`}
                      sx={{ pl: 4 }}
                      onClick={() => handleItemClick()}
                      className="drawer-subitem"
                    >
                      <ListItemIcon sx={{ minWidth: "40px" }}>
                        <AttachMoney style={{ color: "#4B4D63" }} />
                      </ListItemIcon>
                      <ListItemText
                        primary="Resumen de caja"
                        primaryTypographyProps={{
                          fontFamily: "Bricolage Grotesque",
                          sx: {
                            fontSize: "14px",
                            color: "#4B4D63",
                            fontWeight: isActive(`/eventos/${eventoId}/caja-resumen`) ? 600 : 400
                          }
                        }}
                      />
                    </ListItem>
                  )}

                </List>
              </Collapse>
            </>
          ) : (
            /* PARA VENDEDORES*/
            <>
              {(userRole === 9) && (
                <>
                  {/* VENTA PRESENCIAL -- VISTA PARA VENDER */}
                  <ListItem
                    button
                    component={Link}
                    to={`/eventos/${eventoId}/venta-presencial`}
                    onClick={() => handleItemClick()}
                    className="drawer-item"
                  >
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <StoreOutlined style={{ color: "#4B4D63" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Venta presencial"
                      primaryTypographyProps={{
                        fontFamily: "Bricolage Grotesque",
                        sx: {
                          fontSize: "14px",
                          color: "#4B4D63",
                          fontWeight: isActive(`/eventos/${eventoId}/venta-presencial`) ? 600 : 400
                        }
                      }}
                    />
                  </ListItem>

                  {/* HISTORIAL DE VENTAS */}
                  <ListItem
                    button
                    component={Link}
                    to={`/eventos/${eventoId}/ventas-caja`}
                    onClick={() => handleItemClick()}
                    className="drawer-item"
                  >
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <TrendingUpOutlined style={{ color: "#4B4D63" }} />
                    </ListItemIcon>
                    <ListItemText
                      primary="Historial de ventas"
                      primaryTypographyProps={{
                        fontFamily: "Bricolage Grotesque",
                        sx: {
                          fontSize: "14px",
                          color: "#4B4D63",
                          fontWeight: isActive(`/eventos/${eventoId}/ventas-caja`) ? 600 : 400
                        }
                      }}
                    />
                  </ListItem>
                </>
              )}
            </>
          )}
        </>
      )}

      {/* STAFF */}
      {userRole !== 5 && userRole !== 6 && userRole !== 7 && userRole !== 8 && userRole !== 9 && userRole !== 10 && (
        <>
          <ListItem
            button
            component={Link}
            to={`/eventos/${eventoId}/staff`}
            onClick={() => handleItemClick()}
            className="drawer-item"
          >
            <ListItemIcon sx={{ minWidth: "40px" }}><PeopleAltOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
            <ListItemText primary="Colaboradores" primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: {
                fontSize: "14px",
                color: "#4B4D63",
                fontWeight: isActive(`/eventos/${eventoId}/staff`) ? 600 : 400
              }
            }} />
          </ListItem>
        </>
      )}

      {/* EDITAR EVENTO */}
      {/* {userRole === 1 && (
        <ListItem
          button
          component={Link}
          to={`/eventos/${eventoId}/editar`}
          onClick={() => handleItemClick()}
          className="drawer-item"
        >
          <ListItemIcon><SettingsOutlined style={{ color: "#4b4d63" }} /></ListItemIcon>
          <ListItemText primary={t("menuTemplate.eventConfiguration")} primaryTypographyProps={{
            fontFamily: "Bricolage Grotesque",
            sx: { color: "#4B4D63", fontWeight: currentPath === `/eventos/${eventoId}/editar` ? 600 : 400 }
          }} />
        </ListItem>
      )} */}


      {userRole === 8 && (
        <>
          <ListItem
            button
            component={Link}
            to={`/eventos/${eventoId}/mis-asistentes`}
            onClick={() => handleItemClick()}
            className="drawer-item"
          >
            <ListItemIcon sx={{ minWidth: "40px" }}><PersonOutlineOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
            <ListItemText primary="Asistentes" primaryTypographyProps={{
              fontFamily: "Bricolage Grotesque",
              sx: {
                fontSize: "14px",
                color: "#4B4D63",
                fontWeight: isActive(`/eventos/${eventoId}/mis-asistentes`) ? 600 : 400
              }
            }} />
          </ListItem>
        </>
      )}
      {(userRole !== 3 && userRole !== 9) && (
        <Divider
          sx={{
            backgroundColor: '#4b4d63',
            width: '100%',
            marginBottom: '10px',
            marginTop: '10px'
          }}
        />
      )}
      {/* DESCARGAR APP */}
      {(userRole !== 3 && userRole !== 9) && (
        <ListItem
          button
          component="div"
          onClick={handleScannerClick}
          className="drawer-item"
          sx={{
            " &:hover": {
              backgroundColor: "#0b0062",
            },
            marginTop: "20px",
            cursor: "pointer",
            backgroundColor: "#5656ff",
            color: "white",
            textDecoration: "none",
          }}
        >
          {/* <ListItemIcon sx={{ minWidth: "40px" }}><FileDownloadOutlined style={{ color: "white" }} /></ListItemIcon> */}
          <ListItemText primary="Descargá la app" primaryTypographyProps={{
            fontFamily: "Bricolage Grotesque",
            sx: {
              textAlign: "center",
              fontSize: "14px",
              color: "white",
              fontWeight: isActive('/') ? 600 : 400
            }
          }} />
        </ListItem>
      )}

      <Divider
        sx={{
          backgroundColor: '#4b4d63',
          width: '100%',
          marginBottom: '10px',
          marginTop: '20px'
        }}
      />

      <ListItem
        button
        onClick={() => {
          if (isMobile) {
            if (typeof window !== "undefined") {
              window.localStorage.setItem("drawerClosedManually", "true");
            }
          }
          toggleDrawer();
        }}
        sx={{
          color: "#4B4D63",
          textDecoration: "none",
          justifyContent: "center",
          marginTop: "10px",
          cursor: "pointer",
        }}
        className="drawer-item"
      >
        <ListItemIcon sx={{ minWidth: "40px" }}>
          <CloseOutlined style={{ color: "#4b4d63" }} />
        </ListItemIcon>
        <ListItemText primary="Ocultar menú" primaryTypographyProps={{
          fontFamily: "Bricolage Grotesque",
          sx: { fontSize: "14px", color: "#4B4D63" }
        }} />
      </ListItem>
      <ListItem
        button
        component={Link}
        to="/eventos"
        onClick={() => handleItemClick()}
        className="drawer-item"
      >
        <ListItemIcon sx={{ minWidth: "40px" }}><ArrowBackOutlined style={{ color: "#4B4D63" }} /></ListItemIcon>
        <ListItemText primary="Mis eventos" primaryTypographyProps={{
          fontFamily: "Bricolage Grotesque",
          sx: { fontSize: "14px", color: "#4B4D63", fontWeight: 400 }
        }} />
      </ListItem>
      {/* MODAL PARA LA APK DE PASSGO PARA ESCANEAR*/}
      <ScannerApkModal
        open={scannerModalOpen}
        handleClose={() => {
          setScannerModalOpen(false);
        }}
      />

    </>
  );
};

export default EventMenu;